// drivers.js
import req from './axios';
import { isMockJs } from './axios'

export const dropDownList = (sendData) => req('get', isMockJs ? '/common/dropDownList' : '/configuration-option/', sendData);


//測試 404
// export const aaa = (sendData) => req('post', isMockJs ? '/greeg/' : `packages/${sendData.id}/ttttt/`, { name: sendData.name });
